import { proxy } from 'valtio';

interface PrivacyChoicesState {
  isModalOpen: boolean;
}

export const privacyChoicesStore = proxy<PrivacyChoicesState>({
  isModalOpen: false,
});

export const openPrivacyChoices = () => {
  privacyChoicesStore.isModalOpen = true;
};

export const closePrivacyChoices = () => {
  privacyChoicesStore.isModalOpen = false;
};

export const setPrivacyChoicesOpen = (open: boolean) => {
  privacyChoicesStore.isModalOpen = open;
};
